import React from 'react'
import { TYPE_AGENCY, TYPE_INFLUENCER } from '../../constants'
import { FormattedMessage } from 'react-intl'

const Choice = ({ setChoice, setStep }) => {


    const handleChoice = (type) => {
        setChoice(type)
        setStep(1)
    }

    return (
        <>
            <h1 className='text-3xl font-bold text-t-light'>
                <FormattedMessage id="great_choice" defaultMessage={"Great Choice"} />
            </h1>
            <p className='text-start text-sm text-t-light w-[90%]'>
                <FormattedMessage id="select_choice" defaultMessage={"Please select your choice"} />
            </p>


            <p className='mt-8'>
            <FormattedMessage id="choice_desc" defaultMessage={"Influencee is not just an influencer search platform for companies, thanks to Influencee you will be able to get over 70% visibility from companies that need visibility. On the other hand, companies will be able to create and manage marketing campaigns with an ease never seen before! What are you waiting for? Create a free account and try its features!"} />
            </p>
            <div className='mt-10 flex flex-wrap gap-x-5 gap-y-3'>
                <button
                    onClick={() => handleChoice(TYPE_INFLUENCER)}
                    className='btn btn-primary'>
                    <FormattedMessage id="im_an_influencer" defaultMessage={"I'm an Influencer"} />
                </button>
                <button
                    onClick={() => handleChoice(TYPE_AGENCY)}
                    className='btn btn-secondary'>
                    <FormattedMessage id="im_looking_for_an_influencer" defaultMessage={"I'm looking for an Influencer"} />
                </button>
            </div>
        </>
    )
}

export default Choice